import React, { useEffect } from "react";

const MultiplexAd = () => {

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch(e){
      console.error("AdSense Error in MultiplexAd:", e.message);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-format="auto"
      data-ad-client="ca-pub-8006485618867521"
      data-ad-slot="7558235124"
    />
  );
};

export default MultiplexAd;